import { reject } from 'lodash';
import env from 'utils/env';
import { STATIC_CATEGORIES } from 'utils/categories';

const { hostname } = env;

// TODO: Clean this up so that the objects don't have indefinite shape
// TODO: Refactor to avoid using negativelyNamedVariable isNotCategory

function createMenuItems(campaignIsOpen, version, categories) {
  const isShopPage = version === 'shop';
  const pageName = isShopPage ? 'THE SHOP' : version.toUpperCase();

  const menuItems = [
    {
      isNotCategory: true,
      id: 'add-ons/edit',
      areChildrenCategories: true,
      name: pageName,
      path: `/${version}`,
      live: campaignIsOpen,
      children: [...STATIC_CATEGORIES, ...categories],
    },
    {
      isNotCategory: true,
      id: 'my-box',
      areChildrenCategories: false,
      name: 'MY BOX',
      path: '/my-box',
      children: [
        {
          isNotCategory: true,
          id: 'view-box',
          areChildrenCategories: false,
          name: 'View Box',
          path: '/my-box',
          children: [],
        },
        {
          isNotCategory: true,
          id: 'customize',
          areChildrenCategories: false,
          name: 'Customize',
          path: '/customize',
          children: [],
        },
      ],
    },
    {
      isNotCategory: true,
      id: 'shop',
      areChildrenCategories: false,
      name: 'SHOP',
      path: '/shop',
      children: [],
    },
    {
      isNotCategory: true,
      id: 'tv',
      areChildrenCategories: false,
      name: 'TV',
      path: `https://tv.${hostname}`,
      children: [],
    },
    {
      isNotCategory: true,
      id: 'offers',
      areChildrenCategories: false,
      name: 'OFFERS',
      path: '/exclusive-offers',
      children: [
        {
          isNotCategory: true,
          id: 'exclusive-offers',
          areChildrenCategories: false,
          name: 'Exclusive Offers',
          path: '/exclusive-offers',
          children: [],
        },
        {
          isNotCategory: true,
          id: 'giveaways',
          areChildrenCategories: false,
          name: 'Giveaways',
          path: '/giveaway',
          children: [],
        },
      ],
    },
    {
      isNotCategory: true,
      id: 'gift',
      areChildrenCategories: false,
      name: 'GIFT',
      path: '/gift',
      children: [],
    },
    {
      isNotCategory: true,
      id: 'magazine',
      areChildrenCategories: false,
      name: 'MAGAZINE',
      path: '/magazine',
      children: [],
    },
    {
      isNotCategory: true,
      id: 'community',
      areChildrenCategories: false,
      name: 'COMMUNITY',
      path: `https://talk.${hostname}`,
      children: [],
    },
  ];

  return isShopPage
    ? reject(menuItems, (item) => item.id === 'shop')
    : menuItems;
}

export default createMenuItems;
